import { render, staticRenderFns } from "./qrcode-upload.vue?vue&type=template&id=cf08a524&scoped=true"
import script from "./qrcode-upload.vue?vue&type=script&lang=js"
export * from "./qrcode-upload.vue?vue&type=script&lang=js"
import style0 from "./qrcode-upload.vue?vue&type=style&index=0&id=cf08a524&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf08a524",
  null
  
)

export default component.exports